import React from "react";
import Layout from "../components/shared/layout";
import ImageIcons from '../components/imageComponent/ImageIcons';
import InnerPageBanner from "../components/shared/innerPageBanner";

const Feedback = () => {
  return (
    <Layout>
      <InnerPageBanner title='Feedback' maxWidth='472px' innerPageBanner={ImageIcons.feedback} />

      <section className='bg-[#f5f8fd]'>
        <div className='container'>
          <h2 className='text-center mb-[30px]'>Feedback</h2>

          <div class="grid lg:grid-cols-3 sm:grid-cols-2 gap-[20px]">
            {feedbackData.map((item) => (
              <div class="bg-[#fff] hover:bg-[#f5f8fd] hover:shadow-[0_0_35px_rgba(140,152,164,0.25)] border border-t-4 border-[#e3e6f0] hover:border-[#723f00] duration-500 rounded-lg flex flex-col justify-between">
                <div class="sm:p-[25px] p-[20px] flex-grow">
                  <p class="mb-0">{item.text}</p>
                </div>
                <div className="sm:p-[25px] p-[20px] flex justify-center items-center border-t border-[#e3e6f0] group">
                  <span className="border-[4px] border-[#e3e6f0] flex justify-center items-center h-[70px] w-[70px] duration-500 relative rounded-full overflow-hidden">
                    <img src={item.image} alt="" />
                  </span>

                  <div className="pl-[20px] text-left w-[calc(100%_-_70px)]">
                    <h5 className="mb-[3px] sm:text-[20px] font-bold">{item.name}</h5>

                    <p className="mb-0">{item.designation}</p>
                  </div>
                </div>
              </div>
            ))}

          </div>



        </div>
      </section>
    </Layout>
  )
}

const feedbackData = [
  {
    name: "Rajesh Verma",
    designation: "Homeowner",
    text: "Angan Homes transformed my dream of owning a home into reality. The seamless process and transparent communication made the journey stress-free. The attention to detail in design and construction exceeded my expectations.",
    image: ImageIcons.clinet1,
  },
  {
    name: "Amitabh Sharma",
    designation: "Satisfied Buyer",
    text: "From the initial consultation to the final handover, Angan Homes demonstrated professionalism and commitment. The quality of materials used and the modern amenities provided truly set them apart.",
    image: ImageIcons.clinet2,
  },
  {
    name: "Vikas Yadav",
    designation: "Proud Resident",
    text: "What impressed me most about Angan Homes was their dedication to customer satisfaction. Any queries I had were promptly addressed, and the team ensured that all my requirements were met with precision.",
    image: ImageIcons.clinet3,
  },
  {
    name: "Saurabh Chauhan",
    designation: "Happy Homeowner",
    text: "Angan Homes offers a perfect blend of luxury and affordability. The strategic location, coupled with state-of-the-art facilities, makes it an ideal choice for families seeking comfort and convenience.",
    image: ImageIcons.clinet4,
  },
  {
    name: "Manoj Patil",
    designation: "Content Resident",
    text: "The architectural design and spacious layouts at Angan Homes are commendable. Living here has provided my family with a serene environment and a strong sense of community.",
    image: ImageIcons.clinet5,
  },
  {
    name: "Rakesh Sinha",
    designation: "Delighted Customer",
    text: "Choosing Angan Homes was one of the best decisions I've made. The project's timely completion and the team's transparency throughout the process instilled great confidence in their services.",
    image: ImageIcons.clinet6,
  },
]

export default Feedback